import React, { useState, FormEvent, ChangeEvent } from 'react';
import './css/updateShopNameForm.css';

interface UpdateShopNameFormProps {
  onSave: (shopName: string) => void;
}

const UpdateShopNameForm: React.FC<UpdateShopNameFormProps> = ({ onSave }) => {
  const [shopName, setShopName] = useState<string>('');

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSave(shopName);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setShopName(e.target.value);
  };

  return (
    <form className="shopname-form" onSubmit={handleSubmit}>
      <h2>Update Shop Name</h2>
      <p className="shopname-description">
        Please enter your shop name as mentioned on your license before proceeding with the certificate request.
      </p>

      <label className='shopName' htmlFor="shopName">
        Shop Name (as per license) <span className="required">*</span>
      </label>
      <input
        id="shopName"
        type="text"
        value={shopName}
        onChange={handleChange}
        placeholder="Enter shop name"
        required
      />

      <button type="submit" className="shopname-save">
        Save and Continue
      </button>
    </form>
  );
};

export default UpdateShopNameForm;
